import { postAlert } from "./quartixApi";

// Aviso de que alguem clicou num dos links de "saiba mais" do rodape da tela de
// login (os tres produtos, em `LandingView.vue`). Vai para o mesmo Telegram dos
// outros alertas, pelo mesmo prefixo `/api/quartix`.
//
// A mensagem leva o mesmo titulo dos tres passos do login ("Login (from
// markets.quartix.io)"): e atividade da mesma tela, e no chat os alertas do
// login sao uma coisa so. Quem a distingue e o `action`, como entre os passos.
//
// Ainda assim nao e um passo de login e nao entra no acumulador do
// `CarouselModalLogin`: nao ha tentativa em curso, nao ha token para agrupar
// nada e a mensagem se basta sozinha. Quem liga este clique a uma entrada mais
// tarde e a marca de visitante (`peekVisitor()` do `visitor.js`), que e
// justamente para isso.
//
// O CAMINHO fica sob `/login/` de proposito, mesmo nao sendo um passo de login:
// o `map $qtx_alert_ip` do nginx tem `~^/api/quartix/login` como ultima regra,
// que e a rede de seguranca de qualquer caminho novo por ali. Um `/learn_more`
// solto cairia no `default ""` do map - e chave vazia no nginx quer dizer SEM
// limite, nao limite zero. Ele ganhou linha propria la (balde `lm:`) de todo
// jeito; a rede de seguranca e para o dia em que alguem esquecer.
const PATH = "login/learn_more";

// Sem `await` e com o erro engolido do lado de quem chama, pelo mesmo motivo
// dos alertas de login: o link abre em outra aba e nao pode ficar esperando -
// nem deixar de abrir - porque a API de e-mail caiu ou porque o nginx devolveu
// 429.
export async function sendLearnMoreAlert(fields) {
  return postAlert(PATH, fields);
}

export default sendLearnMoreAlert;
